module.exports = __webpack_public_path__ + "bg-new.bf66cdd7052ccb21f4ba.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/assets/images/bg-new.png
// module id = ../../../../../src/assets/images/bg-new.png
// module chunks = main